import React from "react";
import CreatableSelect from "react-select/creatable";

const CreateLeadCareerCounsellingForm = ({
  mode,
  formData,
  setFormData,
  handleChange,
  transformTagsToOptions,
  handleMultiSelectChange,
  sectionsRef,
}) => {
  const transformTagsToOptionsSubjects = (values) => {
    if (!values) return [];
    return values.split(", ").map((value) => ({ value, label: value }));
  };

  const handleMultiSelectChangeSubjects = (selectedOptions, fieldName) => {
    const values = selectedOptions.map((option) => option.value).join(", "); // Convert array to string
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: values,
    }));
  };
  return (
    <>
      <div
        className="p-6 border-b-2 border-gray-300"
        ref={sectionsRef.parentInformation}
        id="parentInformation"
      >
        <h2 className="text-lg font-semibold text-purple-700 mb-4">
          Parents & Family Business
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Parent's Occupation */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Parent's Email
            </label>
            {mode === "view" ? (
              <p className="text-gray-600">
                {formData.parent_email || "Not specified"}
              </p>
            ) : (
              <input
                type="text"
                name="parent_email"
                value={formData.parent_email}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-md p-2 focus:ring-purple-500"
                placeholder="Enter parent's email"
              />
            )}
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Parent's Occupation
            </label>
            {mode === "view" ? (
              <p className="text-gray-600">
                {formData.parents_occupation || "Not specified"}
              </p>
            ) : (
              <input
                type="text"
                name="parents_occupation"
                value={formData.parents_occupation}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-md p-2 focus:ring-purple-500"
                placeholder="Enter parent's occupation"
              />
            )}
          </div>

          {/* Join Father's Business */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Do you wish to join your father’s business after completing
              education?
            </label>
            {mode === "view" ? (
              <p className="text-gray-600">
                {formData.join_family_business || "Not specified"}
              </p>
            ) : (
              <div className="flex items-center space-x-4">
                <label className="flex items-center space-x-2">
                  <input
                    type="radio"
                    name="join_family_business"
                    value="Yes"
                    checked={formData.join_family_business === "Yes"}
                    onChange={handleChange}
                    className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                  />
                  <span className="text-sm text-gray-600">Yes</span>
                </label>
                <label className="flex items-center space-x-2">
                  <input
                    type="radio"
                    name="join_family_business"
                    value="No"
                    checked={formData.join_family_business === "No"}
                    onChange={handleChange}
                    className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                  />
                  <span className="text-sm text-gray-600">No</span>
                </label>
                <label className="flex items-center space-x-2">
                  <input
                    type="radio"
                    name="join_family_business"
                    value="Maybe"
                    checked={formData.join_family_business === "Maybe"}
                    onChange={handleChange}
                    className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                  />
                  <span className="text-sm text-gray-600">Maybe</span>
                </label>
              </div>
            )}
          </div>
        </div>
      </div>
      <div
        className="p-6 border-b-2 border-gray-300"
        ref={sectionsRef.educationCareer}
        id="educationCareer"
      >
        <h2 className="text-lg font-semibold text-purple-700 mb-4">
          Education & Career Information
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {[
            {
              label: "Current Education",
              name: "current_education",
            },
            {
              label: "Previous Education",
              name: "previous_education",
            },
            // {
            //   label: "Last Qualification (%)",
            //   name: "last_qualification_percentage",
            // },
          ].map(({ label, name }) => (
            <div key={name} className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {label}
              </label>
              {mode === "view" ? (
                <p className="text-gray-700">{formData[name] || "N/A"}</p>
              ) : (
                <input
                  type={
                    name === "last_qualification_percentage" ? "number" : "text"
                  }
                  name={name}
                  value={formData[name] || ""}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-md p-2 focus:ring-purple-500"
                  placeholder={`Enter ${label.toLowerCase()}`}
                />
              )}
            </div>
          ))}

          {/* Average GPA/Percentage Selection */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Average GPA/Percentage
            </label>
            {mode === "view" ? (
              <p className="text-gray-700">
                {formData.gpa_percentage || "N/A"}
              </p>
            ) : (
              <select
                id="gpa_percentage"
                name="gpa_percentage"
                className="w-full border border-gray-300 rounded-md p-2"
                value={formData.gpa_percentage && formData.gpa_percentage}
                onChange={handleChange}
                disabled={mode === "view"}
              >
                <option value="">Select...</option>
                <option value="percentage">Percentage</option>
                <option value="gpa">GPA</option>
              </select>
            )}
          </div>

          {/* Conditionally Render Percentage Input */}
          {formData.gpa_percentage === "percentage" && (
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Enter Percentage
              </label>
              <input
                type="number"
                name="percentage"
                value={formData.percentage || ""}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-md p-2"
                placeholder="Enter percentage"
                disabled={mode === "view"}
              />
            </div>
          )}

          {/* Conditionally Render GPA Input */}
          {formData.gpa_percentage === "gpa" && (
            <div className="mb-4 flex gap-2">
              <div className="w-1/2">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Enter GPA
                </label>
                <input
                  type="number"
                  step="0.01"
                  name="gpa"
                  value={(formData.gpa && formData.gpa) || ""}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-md p-2"
                  placeholder="Enter GPA"
                  disabled={mode === "view"}
                />
              </div>
              <div className="w-1/2">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Out of
                </label>
                <input
                  type="number"
                  name="out_off"
                  value={(formData.out_off && formData.out_off) || ""}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-md p-2"
                  placeholder="Enter scale (e.g., 4, 5, 10)"
                  disabled={mode === "view"}
                />
              </div>
            </div>
          )}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Subjects you love studying
            </label>
            {mode === "view" ? (
              <p className="text-gray-700">
                {formData.subjects_liked?.join(", ") || "N/A"}
              </p>
            ) : (
              <input
                type="text"
                name="subjects_liked"
                value={formData.subjects_liked}
                onChange={handleChange}
                className="border rounded-lg p-2 mt-1 w-full"
                required
              />
            )}
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Subjects you dislike studying
            </label>
            {mode === "view" ? (
              <p className="text-gray-700">
                {formData.subjects_disliked?.join(", ") || "N/A"}
              </p>
            ) : (
              <input
                type="text"
                name="subjects_disliked"
                value={formData.subjects_disliked}
                onChange={handleChange}
                className="border rounded-lg p-2 mt-1 w-full"
              />
            )}
          </div>
        </div>
      </div>
      <div
        className="p-6 border-b-2 border-gray-300"
        ref={sectionsRef.attributesHobbies}
        id="attributes-hobbies"
      >
        <h2 className="text-lg font-semibold text-purple-700 mb-4">
          Attributes & Hobbies
        </h2>
        <div>
          {/* Personal Attributes & Preferences */}
          <div className=" p-2 border-b-2 border-gray-300">
            <h2 className="text-lg font-semibold mb-4">
              1. Personal Attributes & Preferences
            </h2>
            {/* <label className="block text-sm font-medium text-gray-700 mb-2">
                    Personal Attributes & Preferences
                  </label> */}
            <div className="grid grid-cols-2 gap-2">
              {[
                "Social",
                "Hardworking",
                "Introvert",
                "Extrovert",
                "Creative",
                "Practical",
                "Team Player",
                "Innovative",
                "Empathetic",
                "Analytical",
              ].map((trait, index) => (
                <div key={index} className="flex items-center">
                  <input
                    type="checkbox"
                    id={trait}
                    className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                    checked={
                      formData.personal_attributes &&
                      formData.personal_attributes.includes(trait)
                    }
                    disabled={mode === "view" ? true : false}
                    onChange={(e) => {
                      if (!formData.personal_attributes) {
                        const updatedAttributes = e.target.checked
                          ? [trait]
                          : formData.personal_attributes.filter(
                              (item) => item !== trait
                            );
                        setFormData({
                          ...formData,
                          personal_attributes: [updatedAttributes],
                        });
                      } else {
                        const updatedAttributes = e.target.checked
                          ? [...formData.personal_attributes, trait]
                          : formData.personal_attributes.filter(
                              (item) => item !== trait
                            );
                        setFormData({
                          ...formData,
                          personal_attributes: updatedAttributes,
                        });
                      }
                    }}
                  />
                  <label htmlFor={trait} className="ml-3 text-sm text-gray-600">
                    {trait}
                  </label>
                </div>
              ))}
            </div>
            {/* Other Attributes */}
            <div className="mt-2">
              <label className="block text-sm font-medium text-gray-700 mb-2 p-1">
                Other Attributes
              </label>
              {mode === "view" ? (
                <p className="text-gray-600 border">
                  {formData.other_attributes || "N/A"}
                </p>
              ) : (
                <input
                  type="text"
                  name="other_attributes"
                  value={formData.other_attributes && formData.other_attributes}
                  onChange={handleChange}
                  className="w-1/2 border border-gray-300 rounded-md p-2 focus:ring-purple-500"
                  placeholder="Enter other attributes"
                />
              )}
            </div>
          </div>
          <div>
            <h2 className="text-lg font-semibold mb-4 p-2">
              2. Hobbies & Extracurricular Interests
            </h2>
            <div className="grid grid-cols-2 gap-2">
              {/* Hobbies & Interests */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Mention your hobbies
                </label>
                {mode === "view" ? (
                  <p className="text-gray-600 border">
                    {formData.hobbies || "N/A"}
                  </p>
                ) : (
                  <textarea
                    name="hobbies"
                    value={formData.hobbies}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-md p-2 focus:ring-purple-500"
                    placeholder="Describe your hobbies"
                    rows="3"
                  ></textarea>
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Have you participated in any competitions in your school life?
                </label>
                {mode === "view" ? (
                  <p className="text-gray-600 border">
                    {formData.competitions_participated ? "Yes" : "No"}
                  </p>
                ) : (
                  // <textarea
                  //   name="competitionsParticipated"
                  //   value={formData.competitionsParticipated}
                  //   onChange={handleChange}
                  //   className="w-full border border-gray-300 rounded-md p-2 focus:ring-purple-500"
                  //   placeholder="Mention competitions"
                  //   rows="3"
                  // ></textarea>
                  <div className="flex items-center space-x-4">
                    <label className="flex items-center space-x-2">
                      <input
                        type="radio"
                        name="competitions_participated"
                        value={true}
                        checked={formData.competitions_participated === true}
                        onChange={handleChange}
                        className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                      />
                      <span className="text-sm text-gray-600">Yes</span>
                    </label>
                    <label className="flex items-center space-x-2">
                      <input
                        type="radio"
                        name="competitions_participated"
                        value={false}
                        checked={formData.competitions_participated === false}
                        onChange={handleChange}
                        className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                      />
                      <span className="text-sm text-gray-600">No</span>
                    </label>
                  </div>
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Are you good at studying theory subjects? Are you an avid
                  reader?
                </label>
                {mode === "view" ? (
                  <p className="text-gray-600 border">
                    {formData.good_at_theory_subjects ? "Yes" : "No"}
                  </p>
                ) : (
                  // <textarea
                  //   name="competitionsParticipated"
                  //   value={formData.competitionsParticipated}
                  //   onChange={handleChange}
                  //   className="w-full border border-gray-300 rounded-md p-2 focus:ring-purple-500"
                  //   placeholder="Mention competitions"
                  //   rows="3"
                  // ></textarea>
                  <div className="flex items-center space-x-4">
                    <label className="flex items-center space-x-2">
                      <input
                        type="radio"
                        name="good_at_theory_subjects"
                        value={true}
                        checked={formData.good_at_theory_subjects === true}
                        onChange={handleChange}
                        className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                      />
                      <span className="text-sm text-gray-600">Yes</span>
                    </label>
                    <label className="flex items-center space-x-2">
                      <input
                        type="radio"
                        name="good_at_theory_subjects"
                        value={false}
                        checked={formData.good_at_theory_subjects === false}
                        onChange={handleChange}
                        className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                      />
                      <span className="text-sm text-gray-600">No</span>
                    </label>
                  </div>
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Kindly Mention theory subjects you're good at
                </label>
                {mode === "view" ? (
                  <p className="text-gray-600 border">
                    {formData.theory_subjects_good_at_details || "N/A"}
                  </p>
                ) : (
                  <textarea
                    name="favoriteTheorySubjects"
                    value={formData.theory_subjects_good_at_details}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-md p-2 focus:ring-purple-500"
                    placeholder="Mention theory subjects"
                    rows="3"
                  ></textarea>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="p-6 border-b-2 border-gray-300 space-y-8"
        ref={sectionsRef.technologyInnovation}
        id="technologyInnovation"
      >
        {/* Technology & Innovation */}
        <div>
          <h2 className="text-lg font-semibold text-purple-700 mb-4">
            Technology, Innovation, & Community Interests
          </h2>
          <div className="p-2 border-b-2 border-gray-300 space-y-2">
            <h2 className="text-lg font-semibold mb-4">
              1. Technology & Innovation
            </h2>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Are you interested in technology and innovation?
              </label>
              {mode === "view" ? (
                <p className="text-gray-600 border">
                  {formData.technology_innovation_details ? "Yes" : "No"}
                </p>
              ) : (
                // <textarea
                //   name="competitionsParticipated"
                //   value={formData.competitionsParticipated}
                //   onChange={handleChange}
                //   className="w-full border border-gray-300 rounded-md p-2 focus:ring-purple-500"
                //   placeholder="Mention competitions"
                //   rows="3"
                // ></textarea>

                <div className="flex items-center space-x-4">
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="technology_innovation_details"
                      value={true}
                      checked={formData.technology_innovation_details === true}
                      onChange={handleChange}
                      className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                    />
                    <span className="text-sm text-gray-600">Yes</span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="technology_innovation_details"
                      value={false}
                      checked={formData.technology_innovation_details === false}
                      onChange={handleChange}
                      className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                    />
                    <span className="text-sm text-gray-600">No</span>
                  </label>
                </div>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                please specify the details about it.
              </label>
              {mode === "view" ? (
                <p className="text-gray-600 border">
                  {formData.technology_innovation_details_text || "N/A"}
                </p>
              ) : (
                <textarea
                  name="technology_innovation_details_text"
                  value={formData.technology_innovation_details_text}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-md p-2 focus:ring-purple-500"
                  placeholder="please Specify the details about it"
                  rows="3"
                ></textarea>
              )}
            </div>
          </div>
          <div className="p-2 border-b-2 border-gray-300 space-y-2">
            <h2 className="text-lg font-semibold mb-4">
              2. Community & Social Service Interests
            </h2>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Are you actively associated with NGO services ? Do you like to
                help community in general?
              </label>
              {mode === "view" ? (
                <p className="text-gray-600 border">
                  {formData.associated_with_ngo ? "Yes" : "No"}
                </p>
              ) : (
                // <textarea
                //   name="competitionsParticipated"
                //   value={formData.competitionsParticipated}
                //   onChange={handleChange}
                //   className="w-full border border-gray-300 rounded-md p-2 focus:ring-purple-500"
                //   placeholder="Mention competitions"
                //   rows="3"
                // ></textarea>

                <div className="flex items-center space-x-4">
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="associated_with_ngo"
                      value={true}
                      checked={formData.associated_with_ngo === true}
                      onChange={handleChange}
                      className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                    />
                    <span className="text-sm text-gray-600">Yes</span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="associated_with_ngo"
                      value={false}
                      checked={formData.associated_with_ngo === false}
                      onChange={handleChange}
                      className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                    />
                    <span className="text-sm text-gray-600">No</span>
                  </label>
                </div>
              )}
            </div>
            <div className="grid grid-cols-2 gap-2">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Are you interested in politics? Do you wish to serve the
                  nation and people as a whole?
                </label>
                {mode === "view" ? (
                  <p className="text-gray-600 border">
                    {formData.interest_in_politics_public_service
                      ? "Yes"
                      : "No"}
                  </p>
                ) : (
                  // <textarea
                  //   name="competitionsParticipated"
                  //   value={formData.competitionsParticipated}
                  //   onChange={handleChange}
                  //   className="w-full border border-gray-300 rounded-md p-2 focus:ring-purple-500"
                  //   placeholder="Mention competitions"
                  //   rows="3"
                  // ></textarea>

                  <div className="flex items-center space-x-4">
                    <label className="flex items-center space-x-2">
                      <input
                        type="radio"
                        name="interest_in_politics_public_service"
                        value={true}
                        checked={
                          formData.interest_in_politics_public_service === false
                        }
                        onChange={handleChange}
                        className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                      />
                      <span className="text-sm text-gray-600">Yes</span>
                    </label>
                    <label className="flex items-center space-x-2">
                      <input
                        type="radio"
                        name="interest_in_politics_public_service"
                        value={false}
                        checked={
                          formData.interest_in_politics_public_service === false
                        }
                        onChange={handleChange}
                        className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                      />
                      <span className="text-sm text-gray-600">No</span>
                    </label>
                  </div>
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  please elaborate
                </label>
                {mode === "view" ? (
                  <p className="text-gray-600 border">
                    {formData.politics_public_service_reason || "N/A"}
                  </p>
                ) : (
                  <textarea
                    name="politics_public_service_reason"
                    value={formData.politics_public_service_reason}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-md p-2 focus:ring-purple-500"
                    placeholder="Mention theory subjects"
                    rows="3"
                  ></textarea>
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Are you human-friendly, patient, and good at understanding
                  people?
                </label>
                {mode === "view" ? (
                  <p className="text-gray-600">
                    {formData.human_friendly || "Not specified"}
                  </p>
                ) : (
                  <div className="flex items-center space-x-4">
                    <label className="flex items-center space-x-2">
                      <input
                        type="radio"
                        name="human_friendly"
                        value="Yes"
                        checked={formData.human_friendly === "Yes"}
                        onChange={handleChange}
                        className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                      />
                      <span className="text-sm text-gray-600">Yes</span>
                    </label>
                    <label className="flex items-center space-x-2">
                      <input
                        type="radio"
                        name="human_friendly"
                        value="No"
                        checked={formData.human_friendly === "No"}
                        onChange={handleChange}
                        className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                      />
                      <span className="text-sm text-gray-600">No</span>
                    </label>
                    <label className="flex items-center space-x-2">
                      <input
                        type="radio"
                        name="human_friendly"
                        value="Not Sure"
                        checked={formData.human_friendly === "Not Sure"}
                        onChange={handleChange}
                        className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                      />
                      <span className="text-sm text-gray-600">Not Sure</span>
                    </label>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="p-2 border-b-2 border-gray-300 space-y-2">
            <h2 className="text-lg font-semibold mb-4">
              3. Design & Construction Interests
            </h2>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Will you be interested in building models and structures? Are
                you fascinated by how buildings are made?
              </label>
              {mode === "view" ? (
                <p className="text-gray-600 border">
                  {formData.interested_in_construction_models ? "Yes" : "No"}
                </p>
              ) : (
                // <textarea
                //   name="competitionsParticipated"
                //   value={formData.competitionsParticipated}
                //   onChange={handleChange}
                //   className="w-full border border-gray-300 rounded-md p-2 focus:ring-purple-500"
                //   placeholder="Mention competitions"
                //   rows="3"
                // ></textarea>

                <div className="flex items-center space-x-4">
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="interested_in_construction_models"
                      value={true}
                      checked={
                        formData.interested_in_construction_models === true
                      }
                      onChange={handleChange}
                      className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                    />
                    <span className="text-sm text-gray-600">Yes</span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="interested_in_construction_models"
                      value={false}
                      checked={
                        formData.interested_in_construction_models === false
                      }
                      onChange={handleChange}
                      className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                    />
                    <span className="text-sm text-gray-600">No</span>
                  </label>
                </div>
              )}
            </div>
            <div className="col-span-2">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Are you interested in fashion or designing related areas where
                creativity and good drawing is required?
              </label>
              {mode === "view" ? (
                <p className="text-gray-600 border">
                  {formData.interested_in_fashion_design ? "Yes" : "No"}
                </p>
              ) : (
                // <textarea
                //   name="competitionsParticipated"
                //   value={formData.competitionsParticipated}
                //   onChange={handleChange}
                //   className="w-full border border-gray-300 rounded-md p-2 focus:ring-purple-500"
                //   placeholder="Mention competitions"
                //   rows="3"
                // ></textarea>

                <div className="flex items-center space-x-4">
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="interested_in_fashion_design"
                      value={true}
                      checked={formData.interested_in_fashion_design === true}
                      onChange={handleChange}
                      className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                    />
                    <span className="text-sm text-gray-600">Yes</span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="interested_in_fashion_design"
                      value={false}
                      checked={formData.interested_in_fashion_design === false}
                      onChange={handleChange}
                      className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                    />
                    <span className="text-sm text-gray-600">No</span>
                  </label>
                </div>
              )}
            </div>
          </div>
          <div className="p-2  space-y-2">
            <h2 className="text-lg font-semibold mb-4">
              4. Career Areas of Interest
            </h2>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Are you interested in the fields of Food, Nutrition, and
                Fitness?
              </label>
              {mode === "view" ? (
                <p className="text-gray-600">
                  {formData.interested_in_food_nutrition || "Not specified"}
                </p>
              ) : (
                <div className="flex items-center space-x-4">
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="interested_in_food_nutrition"
                      value="Yes"
                      checked={formData.interested_in_food_nutrition === "Yes"}
                      onChange={handleChange}
                      className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                    />
                    <span className="text-sm text-gray-600">Yes</span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="interested_in_food_nutrition"
                      value="No"
                      checked={formData.interested_in_food_nutrition === "No"}
                      onChange={handleChange}
                      className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                    />
                    <span className="text-sm text-gray-600">No</span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="interested_in_food_nutrition"
                      value="Only for General Knowledge purpose"
                      checked={
                        formData.interested_in_food_nutrition ===
                        "Only for General Knowledge purpose"
                      }
                      onChange={handleChange}
                      className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                    />
                    <span className="text-sm text-gray-600">
                      Only for General Knowledge purpose
                    </span>
                  </label>
                </div>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Are you interested in understanding Film-related career options?
              </label>
              {mode === "view" ? (
                <p className="text-gray-600">
                  {formData.film_related_career_option || "Not specified"}
                </p>
              ) : (
                <div className="flex items-center space-x-4">
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="film_related_career_option"
                      value="Yes"
                      checked={formData.film_related_career_option === "Yes"}
                      onChange={handleChange}
                      className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                    />
                    <span className="text-sm text-gray-600">Yes</span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="film_related_career_option"
                      value="No"
                      checked={formData.film_related_career_option === "No"}
                      onChange={handleChange}
                      className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                    />
                    <span className="text-sm text-gray-600">No</span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="film_related_career_option"
                      value="Maybe- Can Consider"
                      checked={
                        formData.film_related_career_option ===
                        "Maybe- Can Consider"
                      }
                      onChange={handleChange}
                      className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                    />
                    <span className="text-sm text-gray-600">
                      Maybe- Can Consider
                    </span>
                  </label>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className="p-6 border-b-2 border-gray-300 space-y-2"
        ref={sectionsRef.careerIntrests}
        id="careerIntrests"
      >
        {/* Career Interests & Future Plans */}
        <h2 className="text-lg font-semibold text-purple-700 mb-4">
          Career Interests & Future Plans
        </h2>
        <div className="p-2 ">
          <h2 className="text-lg font-semibold mb-4 p-2">
            1. Specific Career Goals
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Career Choices */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Any specific career choices in mind? (Reasons)
              </label>
              {mode === "view" ? (
                <p className="text-gray-600">
                  {formData.career_choices || "Not specified"}
                </p>
              ) : (
                <textarea
                  name="career_choices"
                  value={formData.career_choices}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-md p-2 focus:ring-purple-500"
                  placeholder="Mention your career choices and reasons"
                  rows="3"
                ></textarea>
              )}
            </div>

            {/* Plans to Study Abroad */}
            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Any plans to study abroad in the future?
              </label>
              {mode === "view" ? (
                <p className="text-gray-600">
                  {formData.plans_to_study_abroad_future || "Not specified"}
                </p>
              ) : (
                <div className="flex items-center space-x-4">
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="plans_to_study_abroad_future"
                      value="Yes"
                      checked={formData.plans_to_study_abroad_future === "Yes"}
                      onChange={handleChange}
                      className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                    />
                    <span className="text-sm text-gray-600">Yes</span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="plans_to_study_abroad_future"
                      value="No"
                      checked={formData.plans_to_study_abroad_future === "No"}
                      onChange={handleChange}
                      className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                    />
                    <span className="text-sm text-gray-600">No</span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="plans_to_study_abroad_future"
                      value="Maybe"
                      checked={
                        formData.plans_to_study_abroad_future === "Maybe"
                      }
                      onChange={handleChange}
                      className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                    />
                    <span className="text-sm text-gray-600">Maybe</span>
                  </label>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className="p-6"
        ref={sectionsRef.selfDescription}
        id="selfDescription"
      >
        <h2 className="text-lg font-semibold text-purple-700 mb-4">
          Self-Description & Final Remarks
        </h2>
        <h2 className="text-lg font-semibold mb-4 p-2">
          1. Personal Introduction
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Personal Introduction */}
          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Tell me about yourself. (Describe yourself in detail and explain
              how are you as a person)
            </label>
            {mode === "view" ? (
              <p className="text-gray-600 w-full">
                {formData.personal_details || "N/A"}
              </p>
            ) : (
              <textarea
                name="personal_details"
                value={formData.personal_details}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-md p-2 focus:ring-purple-500"
                placeholder="Tell me about yourself (Detailed description)"
                rows="4"
              ></textarea>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateLeadCareerCounsellingForm;
